import { render, staticRenderFns } from "./GeneralFormPart.vue?vue&type=template&id=a11ea452&"
import script from "./GeneralFormPart.vue?vue&type=script&lang=js&"
export * from "./GeneralFormPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports